var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "statistic-list-box" },
    _vm._l(_vm.statisticsData, function (item, index) {
      return _c(
        "el-card",
        {
          key: index,
          staticClass: "statistic-card",
          attrs: {
            bordered: false,
            "dis-hover": "",
            padding: 12,
            shadow: "never",
          },
        },
        [
          _c("div", { staticClass: "statistic-box flex-column color-333" }, [
            _c("div", { staticClass: "fs-16 fw-500" }, [
              _vm._v(_vm._s(item.name)),
            ]),
            _c("div", { staticClass: "fs-34 fw-600 mt-16" }, [
              _vm._v(_vm._s(item.value)),
            ]),
            item.isCumulativeData
              ? _c("div", { staticClass: "mt-16" }, [
                  _c("span", [_vm._v("累计至：" + _vm._s(_vm.todayDate))]),
                ])
              : _c("div", { staticClass: "mt-16" }, [
                  _c("span", [_vm._v("环比增长：")]),
                  _c(
                    "span",
                    { class: item.increased ? "color-up" : "color-down" },
                    [
                      _vm._v(_vm._s(item.growthRate) + " "),
                      item.increased
                        ? _c("i", { staticClass: "el-icon-caret-top" })
                        : _c("i", { staticClass: "el-icon-caret-bottom" }),
                    ]
                  ),
                ]),
          ]),
        ]
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }